import Sms from "../../../model/sms/Sms";

/**
 * Text messages (sms) fetched action.
 */
export const SMS_FETCHED = "SMS_FETCHED";
export type SMS_FETCHED = { textMessages: Sms[] };